import React from "react";
import "./app-wide.css";
import "./footersection.css";
import { FaSquareInstagram } from "react-icons/fa6";
import { PiInstagramLogoFill } from "react-icons/pi";
import { FaSquareXTwitter } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";




const FooterSection = ()=>{
    const navigate = useNavigate();

    const navigateToTerms = () => {
        navigate("/termsofservice");
    }

    const navigateToPrivacy = () =>{
        navigate("/privacypolicy");
    }

    return(
        <div className="grid-container-footer">
            <div className="grid-item-footer">
                <div className="grid-container-footer-bottom">
                    <div className="grid-item-footer-bottom">
                    <p>© 2025 StockAchives</p>
                    </div>
                    <div className="grid-item-footer-bottom">
                       <p></p>
                    </div>
                    <div className="grid-item-footer-bottom">
                        <p></p>
                    </div>
                    <div onClick={navigateToPrivacy} className="grid-item-footer-bottom link-privacy-term-text">
                       <p>Privacy Policy</p>
                    </div>
                    <div  onClick={navigateToTerms} className="grid-item-footer-bottom link-privacy-term-text">
                        <p>Terms Of Use</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FooterSection;

// © 2025 StockAchives